/**
 * Created by Timur on 21.08.2026
 */

const Merge2MissionVipPass = function (library, data) {
    this.library = library;

    this.claimed = data.claimed || 0;
    this.claimedVip = data.claimedVip || 0;
    this.vip = data.vip || 0;
};

Merge2MissionVipPass.prototype.getStages = function () {
    return bundles.merge2mission_config.jsons.merge2mission_vippass_json.getJson().stages;
};

Merge2MissionVipPass.prototype.getStagePrize = function (stage, vip) {
    const config = this.getStages()[stage];

    return {
        items: config[vip ? "vipItems" : "freeItems"] || [],
        reward: config[vip ? "vipReward" : "freeReward"]
    };
};

Merge2MissionVipPass.prototype.isUnlocked = function () {
    return this.vip;
};

Merge2MissionVipPass.prototype.isStageReached = function (stage) {
    const required = this.getStages()[stage].required;

    return this.library.isDiscovered(required.code, required.stage);
};

Merge2MissionVipPass.prototype.isClaimed = function (stage, vip) {
    const mask = vip ? this.claimedVip : this.claimed;

    return Boolean(mask & (1 << stage));
};

Merge2MissionVipPass.prototype.canClaim = function (stage, vip) {
    if (vip && !this.isUnlocked()) {
        return false;
    }

    return this.isStageReached(stage) && !this.isClaimed(stage, vip);
};

Merge2MissionVipPass.prototype.countClaimableStages = function () {
    return this.getStages().reduce((total, stage, index) => total
        + (this.canClaim(index, false) ? 1 : 0)
        + (this.canClaim(index, true) ? 1 : 0), 0);
};

Merge2MissionVipPass.prototype.hasClaimableStages = function () {
    return this.countClaimableStages() > 0;
};

Merge2MissionVipPass.prototype.claim = function (stage, vip) {
    if (!this.canClaim(stage, vip)) {
        return undefined;
    }

    if (vip) {
        this.claimedVip |= (1 << stage);
    } else {
        this.claimed |= (1 << stage);
    }

    const prize = this.getStagePrize(stage, vip);
    const reward = { ...prize.reward };

    if (prize.items.length) {
        reward.merge2MissionItems = prize.items;
    }

    return reward;
};

Merge2MissionVipPass.prototype.unlock = function () {
    this.vip = 1;
};

Merge2MissionVipPass.prototype.getInfo = function () {
    return {
        claimed: this.claimed || undefined,
        claimedVip: this.claimedVip || undefined,
        vip: this.vip ? 1 : 0
    };
};

Merge2MissionVipPass.prototype.getAllUnclaimedRewards = function () {
    let rewards = {};

    this.getStages().forEach((config, stage) => {
        if (this.isStageReached(stage) && !this.isClaimed(stage, false)) {
            rewards = RewardsList.sumRewards(rewards, config.freeReward);
        }
        if (this.isUnlocked() && this.isStageReached(stage) && !this.isClaimed(stage, true)) {
            rewards = RewardsList.sumRewards(rewards, config.vipReward);
        }
    });

    return rewards;
};

Merge2MissionVipPass.getProduct = function (mission) {
    return Product.CreateById(bundles.merge2mission_config.jsons.merge2mission_vippass_json.getJson().vipPass.product, {
        type: "merge2mission_vippass",
        mission: mission.type
    });
};

Merge2MissionVipPass.buy = function (mission, callback) {
    const product = mission.isRunning() ? Merge2MissionVipPass.getProduct(mission) : undefined;
    if (!product) {
        callback(undefined);
        return;
    }

    product.buy((success) => {
        const running = success && cleverapps.missionManager.findRunningMission(mission.type);

        callback(running && running.logic.unlockVipPass() ? RewardsConfig.Merge2MissionVipPass : undefined);
    }, { noRewardWindow: true });
};

Restorable.BY_TYPE["merge2mission_vippass"] = new Restorable({
    location: "main",
    find: Restorable.FindRunningMission,
    give: (mission) => {
        if (mission.logic.unlockVipPass()) {
            cleverapps.paymentsLogic.showRestoredWindow(RewardsConfig.Merge2MissionVipPass);
        }
    }
});
